import React, { type FC } from 'react'

import { NotificationSeverity, selectAuthenticatedNearExpiration, Translation } from '../../../domain'

import { Banner, Countdown, useIsMobile } from '../common'
import { FormattedTranslation } from '../Internationalization'
import { useAppState } from '../State'

/**
 * On phones the countdown has no room in the bar, so it shows across the page instead, until the session ends.
 * Not a live region: the "Session ends soon" window already announces the warning once, and a live countdown would be re-read every second.
 */
export const SessionBanner: FC = () => {
    const nearExpiration = useAppState(selectAuthenticatedNearExpiration)
    const isMobile = useIsMobile()

    if (nearExpiration === null || !isMobile) {
        return null
    }

    return (
        <Banner
            data-testid="session-banner"
            severity={NotificationSeverity.WARNING}
            live={false}
            title={<FormattedTranslation id={Translation.SESSION_BANNER} values={{ countdown: <Countdown value={nearExpiration} /> }} />}
        />
    )
}
